import { useEffect, useState } from "react";
import { g } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bike, ExternalLink, Info, Percent } from "lucide-react";

export default function Delivery() {
  const [data, setData] = useState(null);
  useEffect(() => {
    g("/delivery/guide").then(setData);
  }, []);

  if (!data) return <p className="text-sm text-slate-500">Caricamento…</p>;

  return (
    <div className="fade-up max-w-4xl space-y-5" data-testid="delivery-guide-page">
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-slate-500">Asporto e delivery</p>
        <h1 className="mt-1 text-3xl font-bold tracking-tight sm:text-4xl">Collega le piattaforme di consegna</h1>
        <p className="mt-1 text-sm text-slate-500">
          Quattro passaggi per canale: gli ordini entrano in Reprehendo e arrivano subito ai reparti.
        </p>
      </div>

      <Card className="p-5" data-testid="delivery-notes">
        <div className="flex items-start gap-3">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
          <ul className="space-y-1 text-sm text-slate-600">
            {data.notes.map((n) => (
              <li key={n}>• {n}</li>
            ))}
          </ul>
        </div>
      </Card>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {data.channels.map((c) => (
          <Card key={c.id} className="overflow-hidden" data-testid={`delivery-channel-${c.id}`}>
            <div className="flex items-center gap-3 p-5" style={{ borderTop: `4px solid ${c.color}` }}>
              <span className="rounded-lg p-2.5" style={{ backgroundColor: `${c.color}22` }}>
                <Bike className="h-5 w-5" style={{ color: c.color }} />
              </span>
              <div className="min-w-0 flex-1">
                <p className="font-head text-lg font-bold">{c.name}</p>
                <p className="font-num flex items-center gap-1 text-xs text-slate-500">
                  <Percent className="h-3 w-3" /> commissione {c.fee_pct}% già impostata
                </p>
              </div>
            </div>
            <ol className="space-y-2 px-5 pb-4">
              {c.steps.map((s, i) => (
                <li key={s} className="flex gap-2.5 text-sm text-slate-600">
                  <span className="font-num flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-slate-900 text-[11px] font-bold text-white">
                    {i + 1}
                  </span>
                  {s}
                </li>
              ))}
            </ol>
            <div className="px-5 pb-5">
              <Button variant="outline" className="w-full" data-testid={`open-portal-${c.id}`} onClick={() => window.open(c.portal, "_blank")}>
                <ExternalLink className="mr-1.5 h-4 w-4" /> Apri il portale {c.name}
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
